module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-calendar-card"
  }, [_c('div', {
    staticClass: "page-calendar-card__date",
    class: {
      'page-calendar-card__date_red': _vm.isWeekend
    }
  }, [_vm._v(_vm._s(_vm.date))]), _c('div', {
    staticClass: "page-calendar-card__month"
  }, [_vm._v(_vm._s(_vm.monthText))]), _c('div', {
    staticClass: "page-calendar-card__info"
  }, [_vm._t("default")], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-fc768806","hasScoped":true,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/calendar/card/component.vue
// module id = 0e33ea7697471f7b54a8
// module chunks = 0